<template>
	<div class="security">
		<security-info />
		<div class="security_email d_flex">
			<div :class="[{ level_on: securityLevel >= 1 }, 'level_1', 'box']">
				<span
					:class="[
						{
							circle_on: securityLevel >= 1,
							circle_url: securityLevel < 1,
						},
						'circle',
					]"
				></span>

				<div class="icon"></div>
				<p class="text_g">{{ $t('merchant.security.level1') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.email') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel === 0">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 1">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div>
			<div :class="[{ level_on: securityLevel >= 2 }, 'level_2', 'box']">
				<span
					:class="[
						{
							circle_on: securityLevel >= 2,
							circle_url: securityLevel < 2,
						},
						'circle',
					]"
				></span>
				<div class="icon"></div>
				<p class="text_b">{{ $t('merchant.security.level2') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.kyc') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel < 2">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 2">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div>
			<div :class="[{ level_on: securityLevel >= 3 }, 'level_3', 'box']">
				<span
					:class="[
						{
							circle_on: securityLevel >= 3,
							circle_url: securityLevel < 3,
						},
						'circle',
					]"
				></span>
				<div class="icon"></div>
				<p class="text_p">{{ $t('merchant.security.level3') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.otp') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel < 3">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 3">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div>
			<!--			<div class="level_4 box" :class="{ level_on: securityLevel >= 4 }">-->
			<!--				<span-->
			<!--					class="circle"-->
			<!--					:class="{-->
			<!--						circle_on: securityLevel >= 4,-->
			<!--						circle_url: securityLevel < 4,-->
			<!--					}"-->
			<!--				></span>-->
			<!--				<div class="icon"></div>-->
			<!--				<p class="text_o">{{ $t('merchant.security.level4') }}</p>-->
			<!--				<h4 class="mb_15">{{ $t('merchant.security.address') }}</h4>-->
			<!--				<div class="display_status uncompleted" v-if="securityLevel < 4">-->
			<!--					{{ $t('merchant.security.authStatus.no') }}-->
			<!--				</div>-->
			<!--				<div class="display_status completed" v-if="securityLevel >= 4">-->
			<!--					{{ $t('merchant.security.authStatus.ok') }}-->
			<!--				</div>-->
			<!--			</div>-->
		</div>
		<div class="security_email_step1" v-if="securityLevel === 0">
			<input
				type="email"
				:placeholder="$t('input.placeholder.email')"
				class="mb_10"
			/>
			<button class="button_bg_red">{{ $t('button.code') }}</button>
		</div>
		<div class="security_email_step1" v-if="securityLevel >= 1">
			<p class="mb_10">{{ $t('merchant.security.title1') }}</p>
			<input type="text" placeholder="1" class="mb_20" ref="" readonly />
			<p class="mb_10">{{ $t('merchant.security.title2') }}</p>
			<input type="text" placeholder="홍길동" class="mb_20" readonly />
		</div>
		<div v-if="0" class="limit gray_back">
			<p class="mb_20">{{ $t('merchant.security.title3') }}</p>
			<ul>
				<li>- {{ $t('merchant.security.text1') }}</li>
				<li>- {{ $t('merchant.security.text2') }}</li>
				<li>- {{ $t('merchant.security.text3') }}</li>
				<li>- {{ $t('merchant.security.text4') }}</li>
			</ul>
		</div>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Merchant/Certification/SecurityInfo';
export default {
	name: 'Security',
	components: { SecurityInfo },
	data() {
		return {
			showTab: null,
			securityLevel: 0,
		};
	},
};
</script>
<style>
.security_email .box .text_p {
	margin-bottom: 5px;
	color: #fe62f5;
	font-size: 14px;
	font-weight: bold;
}
.security_email .box .text_o {
	margin-bottom: 5px;
	color: #fe4e4e;
	font-size: 14px;
	font-weight: bold;
}
.display_status {
	display: inline-block;
	padding: 10px 20px;
	min-width: 89px;
	font-size: 14px;
	font-weight: normal;
	text-align: center;
	line-height: normal;
	border: 1px solid #ddd;
	border-radius: 10px;
	pointer-events: none;
}
.uncompleted {
	color: #ccc;
	background-color: #fff;
}
.completed {
	color: #fff;
	border-color: #ca0000;
	background-color: #ca0000;
}

.security_email .level_3 .icon {
	height: 77px;
	background-image: url('../../../assets/images/icon/password.png');
	background-position: 0 20px;
	background-repeat: no-repeat;
	background-size: 80px 46px;
}
.security_email .level_3 .circle_url {
	background: url('../../../assets/images/icon/three_gray.png');
	background-size: cover;
}
.security_email .level_4 .icon {
	height: 77px;
	background-image: url('../../../assets/images/icon/accout_security.png');
}
.security_email .level_4 .circle_url {
	background: url('../../../assets/images/icon/four_gray.png');
	background-size: cover;
}
.security_email .level_2 {
	border-right: 1px solid #ddd;
}
</style>
